import usePrompt from "../../lib/appfuse-react/hook/usePrompt";
import {useState} from "react";
import lang from "../../lib/appfuse-react/core/lang";
import UserEvent from "../../lib/appfuse-react/core/UserEvent";
import {Dialog, DialogContent, Divider, Grid, Typography} from "@material-ui/core";
import Box from "../../lib/appfuse-react/component/Box";
import i18n from "../../lib/appfuse-react/core/i18n";
import Form from "../../lib/appfuse-react/component/Form";
import {Close, Done, Send} from "@material-ui/icons";
import TextField from "../../lib/appfuse-react/component/TextField";
import Button from "../../lib/appfuse-react/component/Button";


function ReapplyActivationForm({onVerify, onResend, onCancel, disabledResend = false}) {
    const prompt = usePrompt();
    const [value, setValue] = useState({});

    const handleChange = (event) => {
        const {value} = event;
        setValue(value);
    };

    const handleVerify = () => {
        const {pin, phoneNumber} = value;
        if(lang.isEmpty(pin)) {
            prompt.confirm('Please enter the verification code.');
            return;
        }
        if (lang.isEmpty(phoneNumber)) {
            prompt.confirm('Please enter the phone number.');
            return;
        }
        onVerify(new UserEvent({pin: pin + phoneNumber, phone: phoneNumber}));
    };

    const handleResend = () => {
        onResend();
    }

    const handleCancel = () => {
        onCancel();
    };

    return (
        <Dialog open={true} maxWidth='xs' fullWidth>
            <Box paddingTop={2} paddingBottom={1}>
                <Typography align='center' variant='h6'>{i18n.translate('Reactivate Account')}</Typography>
            </Box>
            <Divider variant='middle'/>
            <DialogContent>
                <Box fullHeight fullWidth overflow='auto' paddingY={2} paddingX={2}>
                    <Form value={value} onChange={handleChange} onSubmit={handleVerify}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Typography variant='body1'>
                                    {i18n.translate("You have not logged in for almost a year, and your account has been suspended.")}
                                </Typography>
                                <Typography variant='body1'>
                                    {i18n.translate("Please enter the following information to reactivate your account.")}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField name='phoneNumber' label='Phone Number First Six Digits' variant='outlined' fullWidth required />
                            </Grid>
                            <Grid item xs={12}>
                                <Box marginBottom={1}>
                                    <Typography style={{whiteSpace: 'pre-wrap'}} variant='body2' color='textSecondary'>
                                        {i18n.translate("An email with a verification code has been sent to you.")}
                                    </Typography>
                                    <Typography style={{whiteSpace: 'pre-wrap'}} variant='body2' color='textSecondary'>
                                        {i18n.translate("Please enter the verification code to finish signing in.")}
                                    </Typography>
                                </Box>
                                {/*驗證碼*/}
                                <TextField name='pin' label='Verification Code' variant='outlined' fullWidth required />
                            </Grid>
                            <Grid item xs={12}>
                                {!disabledResend && (
                                    <Box display="flex" justifyContent="flex-end">
                                        <Button text="Resend verification code." color="primary" size="small" onClick={handleResend} startIcon={<Send/>}/>
                                    </Box>)
                                }
                            </Grid>
                            <Grid item xs={6}>
                                <Button startIcon={<Done/>} text='OK' variant='contained' color='primary' fullWidth onClick={handleVerify}/>
                            </Grid>
                            <Grid item xs={6}>
                                <Button startIcon={<Close/>} text='Cancel' variant='contained' color='primary' fullWidth onClick={handleCancel}/>
                            </Grid>
                        </Grid>
                    </Form>
                </Box>
            </DialogContent>
        </Dialog>
    );
}

export default ReapplyActivationForm;